import React, { useState } from "react";
import { Container, Card, CardBody, Form, FormGroup, Label, Input, Button } from "reactstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { SUPPORT_EMAIL } from "../components/Footer";
import "./ContactPage.css";

const SALES_PRODUCTS = [
  "Baremetal Servers",
  "Virtual Servers",
  "DevOps Services",
  "Remote Desktop",
];

const SalesPage = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [businessEmail, setBusinessEmail] = useState("");
  const [businessPhone, setBusinessPhone] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [product, setProduct] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(
      `Sales enquiry from Hosting Noodle: ${firstName} ${lastName} (${companyName || "—"})`
    );
    const body = encodeURIComponent(
      `${message || "(No message)"}\n\n---\n` +
      `First name: ${firstName || "—"}\n` +
      `Last name: ${lastName || "—"}\n` +
      `Business email: ${businessEmail || "—"}\n` +
      `Business phone: ${businessPhone || "—"}\n` +
      `Company: ${companyName || "—"}\n` +
      `Product of interest: ${product || "—"}`
    );
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
  };

  return (
    <>
      <Navbar />
      <main className="hn-contact-main">
        <Container className="py-4 py-md-5">
          <h1 className="hn-contact-title">Sales</h1>
          <p className="hn-contact-intro text-muted mb-4">
            Interested in our plans for your business? Fill in the form below and we&apos;ll get back to you. Submitting will open your email client with your details addressed to our team.
          </p>
          <Card className="hn-contact-card" style={{ maxWidth: "36rem" }}>
            <CardBody className="p-4">
              <h2 className="hn-contact-heading mb-3">Contact sales</h2>
              <Form onSubmit={handleSubmit}>
                <div className="row g-2">
                  <div className="col-md-6">
                    <FormGroup>
                      <Label for="sales-firstname">First name</Label>
                      <Input
                        id="sales-firstname"
                        type="text"
                        placeholder="First name"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        autoComplete="given-name"
                      />
                    </FormGroup>
                  </div>
                  <div className="col-md-6">
                    <FormGroup>
                      <Label for="sales-lastname">Last name</Label>
                      <Input
                        id="sales-lastname"
                        type="text"
                        placeholder="Last name"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        autoComplete="family-name"
                      />
                    </FormGroup>
                  </div>
                </div>
                <FormGroup>
                  <Label for="sales-email">Business email address</Label>
                  <Input
                    id="sales-email"
                    type="email"
                    placeholder="you@company.com"
                    value={businessEmail}
                    onChange={(e) => setBusinessEmail(e.target.value)}
                    required
                    autoComplete="email"
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="sales-phone">Business phone number</Label>
                  <Input
                    id="sales-phone"
                    type="tel"
                    placeholder="+1 234 567 8900"
                    value={businessPhone}
                    onChange={(e) => setBusinessPhone(e.target.value)}
                    autoComplete="tel"
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="sales-company">Company name</Label>
                  <Input
                    id="sales-company"
                    type="text"
                    placeholder="Your company"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    autoComplete="organization"
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="sales-product">Product</Label>
                  <Input
                    id="sales-product"
                    type="select"
                    value={product}
                    onChange={(e) => setProduct(e.target.value)}
                  >
                    <option value="">Select a product</option>
                    {SALES_PRODUCTS.map((p) => (
                      <option key={p} value={p}>{p}</option>
                    ))}
                  </Input>
                </FormGroup>
                <FormGroup>
                  <Label for="sales-message">Message</Label>
                  <Input
                    id="sales-message"
                    type="textarea"
                    rows={4}
                    placeholder="Tell us about your needs..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </FormGroup>
                <Button type="submit" color="warning" className="hn-contact-submit">
                  Open email to send
                </Button>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </main>
      <Footer />
    </>
  );
};

export default SalesPage;
